import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Restaurant } from 'src/interfaces/restaurant.model';
import { LANGUAGE_NAMES } from '../desktop-translations';

/** Страницы приложения в магазинах — заглушки, пока страницы не оформлены (ROADMAP, «Магазины») */
const APP_STORE_URL: string | null = null;
const GOOGLE_PLAY_URL: string | null = null;

/**
 * Подвал десктоп-меню: заведение, призыв для заведений (веб-версия Edim →
 * регистрация), приложение Edim (App Store, Google Play);
 * внизу — язык меню, © и политика конфиденциальности
 */
@Component({
    selector: 'app-desktop-footer',
    templateUrl: './desktop-footer.component.html',
    styleUrls: ['./desktop-footer.component.css'],
    standalone: false
})
export class DesktopFooterComponent {
  @Input({ required: true }) restaurant!: Restaurant;
  @Input() languages: string[] = [];
  @Input() language = '';
  @Input() showContacts = false;
  @Input() linkCopied = false;

  @Output() languageChange = new EventEmitter<string>();
  @Output() contacts = new EventEmitter<void>();
  @Output() copyLink = new EventEmitter<void>();

  readonly signUpUrl = `${environment.appUrl}/signUp`;
  readonly appStoreUrl = APP_STORE_URL;
  readonly googlePlayUrl = GOOGLE_PLAY_URL;
  readonly year = new Date().getFullYear();
  readonly names = LANGUAGE_NAMES;

  get policyUrl(): string {
    return this.language.startsWith('sr')
      ? 'https://legal.edim.app/srb/privacy'
      : 'https://legal.edim.app/srb/en/privacy';
  }
}
